// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"91db36a1","308":"fb6d2eb0"}[chunkId] + ".chunk.css";
};